import * as yup from 'yup';

import Base from './Base';

const passwordResetSchema = yup.object().shape({
  currentPassword: yup.string().required('Current password is required'),
  newPassword: yup
    .string()
    .required('New password is required')
    .min(8, 'Password must be at least 8 characters')
    .isPassword()
    .test('not-same-as-current', 'New password cannot be the same as current password', function (value) {
      const { currentPassword } = this.parent;
      return value !== currentPassword;
    }),
  repeatPassword: yup
    .string()
    .required('Repeat password is required')
    .oneOf([yup.ref('newPassword')], 'Passwords must match'),
});

export default class ChangePassword extends Base {
  static validateCreate(item, fields) {
    return super.validate(item, fields, passwordResetSchema);
  }

  oldPassword = '';
  newPassword = '';
  repeatPassword = '';
}
